export default "__VITE_ASSET__0daYCEkN__"